import { add, Dinero } from "dinero.js"
import { DeliveryWithCart } from "../../form/formTypes"
import { toDinero } from "../../../../../../modules/currency/currencyLib"

export function buildInitialQuantityKey({
    deliveryTime,
    productId,
    isExtraService,
}: Readonly<{
    deliveryTime: string
    productId: string | number
    isExtraService?: boolean
}>) {
    return `${deliveryTime}|${productId}|${isExtraService ? "1" : "0"}`
}

export function buildInitialRefundQuantities(deliveryTimes: ReadonlyArray<DeliveryWithCart>) {
    const initial: Record<string, number> = {}

    for (const delivery of deliveryTimes) {
        const time = delivery.time ?? ""
        for (const line of delivery.orderLines) {
            const key = buildInitialQuantityKey({
                deliveryTime: time,
                productId: line.id,
                isExtraService: line.isExtraService,
            })
            initial[key] = (initial[key] ?? 0) + (line.quantity ?? 0)
        }
    }

    return initial
}

export function calculateTotalAmountFromDeliveries(
    deliveryTimes: DeliveryWithCart[],
    fallbackCurrency: string = "DKK",
): Dinero<number> {
    const defaultPrice = toDinero({ amount: 0, scale: 2, currency: fallbackCurrency })

    return deliveryTimes.reduce((total: Dinero<number>, delivery) => {
        const deliveryTotal = delivery.orderLines.reduce((sum, p) => {
            return add(
                sum,
                p.price
                    ? toDinero({
                          amount: p.price.amount * p.quantity,
                          scale: p.price.scale,
                          currency: p.price.currency,
                      })
                    : defaultPrice,
            )
        }, defaultPrice)

        return add(total, deliveryTotal)
    }, defaultPrice)
}
